import { useMemo } from 'react';

import { numberWithCommas } from '../../../helpers/common';

import { UNIT } from '../../../constants/common';

const usePreparedGeofenceData = ({ geofence }) => {
  return useMemo(() => {
    const columnOneData = [
      {
        label: 'Pasture ID',
        value: geofence?.identifier,
        isVisible: true
      },
      {
        label: 'Pasture Name',
        value: geofence?.name,
        isVisible: true
      },
      {
        label: 'Pasture Size (ha)',
        value: numberWithCommas(Number(geofence?.size).toFixed(2)),
        isVisible: true
      },
      {
        label: 'Pasture Perimeter (km)',
        value: numberWithCommas(Number(geofence?.circumference).toFixed(2)),
        isVisible: true
      },
      {
        label: 'Pasture Description',
        value: geofence?.description,
        isVisible: true
      },
      {
        label: 'Carrying Capacity',
        value: geofence?.carrying_capacity ? `${geofence?.carrying_capacity} ${UNIT.STOCK_RATE}` : '/',
        isVisible: true
      }
    ];

    return { columnOneData };
  }, [geofence]);
};

export default usePreparedGeofenceData;
